import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { AditivoIrcpIrfe } from '../../models/aditivo-ircp-irfe.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { IrcpProjetoService } from '../../services/ircp-projeto.service';
import { IrfeProjetoService } from '../../services/irfe-projeto.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';

@Component({
  selector: 'app-aditivo-ircp-irfe-list',
  templateUrl: './aditivo-ircp-irfe-list.component.html',
  styleUrls: ['./aditivo-ircp-irfe-list.component.scss']
})
export class AditivoIrcpIrfeListComponent extends BaseListComponent<AditivoIrcpIrfe> implements OnInit, OnDestroy {

  @Input() idIrfe: number;
  @Input() idIrcp: number;
  @Input() canSave: boolean = false;
  myId: number;
  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  myService: any;
  list: AditivoIrcpIrfe[] = [];

  constructor(
    private irfeService: IrfeProjetoService,
    private ircpService: IrcpProjetoService,
    private router: Router,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  ngOnInit() {
    this.loading();

    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
    });

    if (this.idIrfe) {
      this.myService = this.irfeService;
      this.myId = this.idIrfe;
    } else {
      this.myService = this.ircpService;
      this.myId = this.idIrcp;
    }

    this.addSub(
      this.myService.getAditivoList(this.myId).subscribe({
        next: (res: AditivoIrcpIrfe[]) => {
          this.list = res;
          this.loaded();
        },
        error: (error) => {
          let msg = error?.error?.message || (error?.error?.match(/{"message":"(.+)"}/)?.[1]) || '';
          this.msgError(msg);
          this.loaded();
        },
      })
    );
  }

  novo() {
    if (this.idIrfe) {
      this.router.navigate([`projetos/projeto/${this.idProjeto}/irfe/${this.idIrfe}/aditivo/adicionar`]);
    } else {
      this.router.navigate([`projetos/projeto/${this.idProjeto}/ircp/${this.idIrcp}/aditivo/adicionar`]);
    }
  }

  editar(data: any): void {
    if (this.idIrfe) {
      this.router.navigate([`projetos/projeto/${this.idProjeto}/irfe/${this.idIrfe}/aditivo/`], { queryParams: { aditivo_id: data.id } });
    } else {
      this.router.navigate([`projetos/projeto/${this.idProjeto}/ircp/${this.idIrcp}/aditivo/`], { queryParams: { aditivo_id: data.id } });
    }
  }

}